module.exports = __webpack_public_path__ + "img/promo-bg.6ca3a07.png";